import axios from "axios";

const api = axios.create({
  baseURL: "https://wstsc.org.au/backend/api",
  // baseURL: "http://127.0.0.1:8000/api",
  headers: {
    Accept: "application/json",
  },
  timeout: 300000,
   withCredentials: false, 
});

// Request interceptor
api.interceptors.request.use(
  (config) => {
    // IMPORTANT: Don't set Content-Type for FormData
    // Let the browser set it with the correct boundary
    if (config.data instanceof FormData) {
      delete config.headers['Content-Type'];
    }
    
    return config;
  },
  (error) => {
    console.error("Request error:", error);
    return Promise.reject(error);
  },
);

// Response interceptor
api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    console.error("API Error:", {
      message: error.message,
      status: error.response?.status,
      url: error.config?.url,
      data: error.response?.data
    });

    return Promise.reject(error);
  },
);

export default api;